// index.js or main file
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, useLocation, Navigate } from 'react-router-dom';
import Login from './pages/login/login';
import AdminRedirect from './adminRedirect/admin';
import Admin from './admin/admin';
import Home from './admin/pages/home/home';
import Rules from './admin/pages/rules/rules';
import { Provider } from 'react-redux';
import { store } from './admin/store';
import LoginPage from './admin/pages/login/login';

import Lobby from './pages/lobby/lobby';
import Content from './pages/content/content';
import Question from './pages/question/question';
import Host from './pages/host/host';
import Game from './pages/game/game';
import ThankYou from './pages/thankyou/thankyou';
import Leaderboard from './pages/leaderboard/Leaderboard';

import USER from './pages/dddUI/user';


function usePageBackground() {
  const location = useLocation();
  useEffect(() => {
    const body = document.body;
    const p = location.pathname;
    if (!p.startsWith("/admin") && !/^\/thankyou\/?$/i.test(p)) {
      body.classList.add("common-bg");
    } else {
      body.classList.remove("common-bg");
    }
  }, [location]);
}

function App() {
  usePageBackground();

  return (
    <Provider store={store}>
      <Routes>
    

        <Route path="*" element={
          <USER>
            <Routes>
              <Route index element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route path="/lobby" element={<Lobby />} />
              <Route path="/content" element={<Content />} />
              <Route path="/question" element={<Question />} />
              <Route path="/host" element={<Host />} />
              <Route path="/game" element={<Game />} />
              <Route path="/thankyou" element={<ThankYou />} />
              <Route path="/leaderboard" element={<Leaderboard />} />
            
            </Routes>
          </USER>
        } />
      </Routes>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();
